<!--
 * @Author: qin 15936669602@163.com
 * @Date: 2025-06-28 15:08:59
 * @LastEditors: qin 15936669602@163.com
 * @LastEditTime: 2025-08-08 22:33:08
 * @FilePath: /360-house-viewing-main/src/components/Layout/Layout.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="layout">
    <AppHeader />
    <main class="main-content">
      <router-view></router-view>
      <!-- 动态内容区域 -->
    </main>
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from "./AppHeader.vue";
import AppFooter from "./AppFooter.vue";

export default {
  name: "Layout",
  components: {
    AppHeader,
    AppFooter,
  },
};
</script>

<style scoped>
.layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.main-content {
  flex: 1;
  /* padding: 20px 0; */
}
</style>
